if (!customElements.get('product-info-tabs-section')) {
  customElements.define(
    'product-info-tabs-section',
    class ProductInfoTabsSection extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-tab-trigger]'));
        this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
        this.faqItems = Array.from(this.querySelectorAll('[data-faq-item]'));

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.activateTab(tab.dataset.tabTarget));
        });

        this.faqItems.forEach((item) => {
          const trigger = item.querySelector('[data-faq-trigger]');
          trigger?.addEventListener('click', () => this.toggleFaq(item));
        });

        const defaultTab = this.tabs.find((tab) => tab.classList.contains('is-active'));
        this.activateTab(defaultTab?.dataset.tabTarget || 'ingredients', false);
      }

      activateTab(panelId, focusTab = true) {
        this.tabs.forEach((tab) => {
          const isActive = tab.dataset.tabTarget === panelId;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        this.panels.forEach((panel) => {
          const isActive = panel.dataset.tabPanel === panelId;
          panel.classList.toggle('is-active', isActive);
          panel.toggleAttribute('hidden', !isActive);
        });

        if (focusTab) {
          const activeTab = this.tabs.find((tab) => tab.dataset.tabTarget === panelId);
          activeTab?.focus();
        }
      }

      toggleFaq(item) {
        const isOpen = item.classList.contains('is-open');
        const allowMultiple = this.dataset.allowMultipleFaq === 'true';

        if (!allowMultiple && !isOpen) {
          this.faqItems.forEach((other) => {
            if (other !== item) this.closeFaq(other);
          });
        }

        if (isOpen) {
          this.closeFaq(item);
        } else {
          this.openFaq(item);
        }
      }

      openFaq(item) {
        item.classList.add('is-open');
        const trigger = item.querySelector('[data-faq-trigger]');
        const panel = item.querySelector('[data-faq-panel]');
        trigger?.setAttribute('aria-expanded', 'true');
        panel?.removeAttribute('hidden');
      }

      closeFaq(item) {
        item.classList.remove('is-open');
        const trigger = item.querySelector('[data-faq-trigger]');
        const panel = item.querySelector('[data-faq-panel]');
        trigger?.setAttribute('aria-expanded', 'false');
        panel?.setAttribute('hidden', '');
      }
    }
  );
}